import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SweetAlert from "react-bootstrap-sweetalert";
import classNames from "classnames";

import { makeStyles } from "@material-ui/core/styles";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import WorkIcon from "@material-ui/icons/Work";

import Button from "components/CustomButtons/Button.js";

import paymentPayPal from "api/paymentPayPal.js";

import shippingAddressStyle from "assets/jss/material-dashboard-pro-react/views/shippingAddressStyle.js";
import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

import { calculateCartNumber } from "util/calculation.js";

const useStyles = makeStyles(shippingAddressStyle);
const useStylesAlert = makeStyles(menuStyle);

export default function CashPayButton(props) {
  const {
    active,
    cart,
    shippingInfo,
    restaurantId,
    paymentResponse,
    totalPrice,
    deliveryPrice,
    servicePrice,
    subPrice,
    language,
    customStyle,
    showPopup,
    mealVoucherArray
  } = props;

  const { t } = useTranslation();
  const classes = useStyles();
  const classesAlert = useStylesAlert();

  const [showAlert, setShowAlert] = useState(false);
  const [select, setSelect] = useState(0);

  const list = mealVoucherArray;

  function onError(err) {
    return paymentResponse(err, "ERROR");
  }

  function onSuccess() {
    // console.log("Transaction completed by ", JSON.stringify(details, null, 2));
    // console.log("Transaction completed by 2 ", JSON.stringify(data, null, 2));
    // console.log("Transaction completed by 3 ", JSON.stringify(props, null, 2));
    setShowAlert(false);
    function compare(a, b) {
      // Use toUpperCase() to ignore character casing
      const idA = a.index;
      const idB = b.index;

      let comparison = 0;
      if (idA > idB) {
        comparison = 1;
      } else if (idA < idB) {
        comparison = -1;
      }
      return comparison;
    }

    cart.sort(compare);

    const dish = cart.map(el => {
      let toDelete = [];
      let selection = [];
      let arrayFree = [];
      let arrayCost = [];
      if (el.ingredientC && Object.keys(el.ingredientC).length > 0) {
        Object.keys(el.ingredientC).forEach(key => {
          const [type, id] = key.split("_");

          if (type === "REMOVE") {
            toDelete = [].concat(toDelete).concat(
              el.ingredientC[key].map(el => ({
                label_it: el.label_it,
                label_en: el.label_en,
                price: el.price,
                quantity: el.quantity
              }))
            );
          } else if (type === "ADD" || type === "CHANGE-QUANTITY") {
            // RESETTO ARRAY FREE
            let arrayFreeSingle = [];
            const maxNumber = el.maxObj && el.maxObj[id] ? el.maxObj[id] : 0;
            // const countQuantity = calculateCartNumber(el.ingredientC[key]);
            el.ingredientC[key].forEach((item, i) => {
              const calcualateArrayFree = calculateCartNumber(arrayFreeSingle);

              if (maxNumber && calcualateArrayFree <= maxNumber) {
                if (item.quantity + calcualateArrayFree > maxNumber) {
                  const copyQuantity = item.quantity;
                  const copyElFree = Object.assign({}, item);
                  const copyElCost = Object.assign({}, item);
                  copyElFree.quantity = maxNumber - calcualateArrayFree;
                  copyElCost.quantity =
                    copyQuantity - (maxNumber - calcualateArrayFree);
                  if (copyElFree.quantity) {
                    arrayFreeSingle = []
                      .concat(arrayFreeSingle)
                      .concat([copyElFree]);
                  }
                  arrayCost = [].concat(arrayCost).concat([copyElCost]);
                } else {
                  arrayFreeSingle = [].concat(arrayFreeSingle).concat([item]);
                }
              } else {
                if (item.price && Number(item.price)) {
                  arrayCost = [].concat(arrayCost).concat([item]);
                } else {
                  arrayFreeSingle = [].concat(arrayFreeSingle).concat([item]);
                }
              }
            });
            arrayFree = [].concat(arrayFree).concat(arrayFreeSingle);
            // selection = [].concat(selection).concat(
            //   el.ingredientC[key].map(el => ({
            //     label_it: el.label_it,
            //     label_en: el.label_en,
            //     price: el.price,
            //     quantity: el.quantity
            //   }))
            // );
            selection = [].concat(arrayCost);
          } else if (type === "SIZE") {
            selection = [].concat(selection).concat(
              el.ingredientC[key].map(el => ({
                label_it: el.label_it,
                label_en: el.label_en,
                price: el.price,
                quantity: el.quantity
              }))
            );
          }
        });
      }

      // console.log("CALCOLO TOTALE", {
      //   toDelete,
      //   selection,
      //   size,
      //   arrayFree,
      //   arrayCost,
      //   el
      // });

      return {
        quantity: el.quantity,
        price: el.price,
        _id: el.productId,
        toDelete,
        selection,
        arrayFree,
        hg: el && el.isPricePerHg && el.hg ? el.hg : "",
        // customIngredients: el.ingredientC,
        note: el.note,
        label_it:
          el.dish && el.dish._id && el.dish._id.label_it
            ? el.dish._id.label_it
            : "",
        label_en:
          el.dish && el.dish._id && el.dish._id.label_en
            ? el.dish._id.label_en
            : "",
        ingredients:
          el.dish && el.dish._id && el.dish._id.ingredients
            ? el.dish._id.ingredients
            : [],
        index: el.index
      };
    });

    //  Call your server to save the transaction
    return paymentPayPal(
      restaurantId,
      null,
      null,
      dish,
      shippingInfo,
      totalPrice,
      deliveryPrice,
      servicePrice,
      subPrice,
      language,
      "buoni pasto",
      list[select].label
    )
      .then(responseJson => {
        if (responseJson && !responseJson.error) {
          return paymentResponse(responseJson, "SUCCESS_CASH");
        } else {
          return paymentResponse(responseJson.error, "ERROR");
        }
      })
      .catch(error => onError(error));
  }

  const confirmClass = classNames({
    [classesAlert.buttonAlert]: true,
    [classesAlert.totalButton]: true
  });

  return (
    <>
      <div>
        <Button
          round
          size="sm"
          style={{ width: "100%", backgroundColor: customStyle.buttonAction }}
          // color="github"
          className={classes.buttonBig}
          color="lightBlue"
          // onClick={onSuccess}
          onClick={() => {
            if (showPopup) {
              setShowAlert(true);
            } else {
              onSuccess();
            }
          }}
          disabled={!active}
        >
          <WorkIcon />
          {/* <img
            className="paypal-button-logo paypal-button-logo-pp paypal-button-logo-blue"
            src={`${config.cdn}icona-pagamento-in-consegna.png`}
            alt="cash"
            style={{ height: "20px", width: "50px", color: "white" }}
          /> */}
          <span className={classes.buttonTextNormal}>
            {t("payment.meal_voucher")}
          </span>
        </Button>
      </div>
      {showAlert ? (
        <SweetAlert
          error={false}
          style={{
            display: "block",
            top: "20%",
            marginTop: "0px",
            paddingBottom: 0,
            maxHeight: "calc(100vh - 150px)",
            overflowY: "auto"
          }}
          onConfirm={onSuccess}
          onCancel={() => {
            setShowAlert(false);
          }}
          // cancelBtnCssClass={`${classesAlert.buttonAlert}`}
          // confirmBtnCssClass={`${confirmClass}`}
          // cancelBtnText={t("menuList.cancel_button").toUpperCase()}
          // confirmBtnText={`${t("shippingAddress.cash_pay").toUpperCase()}`}
          // style={{ display: "block", marginTop: "-100px" }}
          title={t("payment.how_pay")}
          showCancel={false}
          showConfirm={false}
        >
          <div>
            <Button
              round
              size="sm"
              color="transparent"
              className={classes.buttonSmall}
              style={{
                border: 0,
                position: "absolute",
                right: "7px",
                top: "5px",
                height: "46px",
                width: "46px",
                borderRadius: "32px"
              }}
              onClick={() => {
                setShowAlert(false);
              }}
            >
              <span className={classes.buttonText} style={{ fontSize: "11px" }}>
                <CloseIcon
                  style={{ marginRight: 0, color: customStyle.buttonAction }}
                />
              </span>
            </Button>
            {list.map((el, index) => {
              return (
                <div
                  onClick={() => {}}
                  key={el._id}
                  style={{
                    position: "relative",
                    borderBottom:
                      index + 1 === list.length ? "none" : "solid 1px #cbcbcb"
                  }}
                >
                  <div
                    className={classes.titleAdd}
                    style={{
                      lineHeight: "40px"
                    }}
                  >
                    <img
                      className="paypal-button-logo paypal-button-logo-pp paypal-button-logo-blue"
                      src={el.icon}
                      alt={el.label}
                      style={{
                        height: "20px",
                        width: "50px",
                        color: "white",
                        objectFit: "contain",
                        marginRight: "5px"
                      }}
                    />
                    {el.label}
                  </div>
                  <Button
                    round
                    size="sm"
                    color="transparent"
                    className={classes.buttonSmall}
                    style={{
                      position: "absolute",
                      top: 0,
                      right: 0,
                      // backgroundColor: customStyle.buttonContinue
                      borderColor: customStyle.buttonAction
                    }}
                    onClick={() => {
                      setSelect(index);
                    }}
                  >
                    <span
                      className={classes.buttonText}
                      style={{
                        fontSize: "11px",
                        paddingLeft: "2px"
                      }}
                    >
                      {select === index ? (
                        <CheckIcon
                          style={{ color: customStyle.buttonAction }}
                        />
                      ) : (
                        ""
                      )}
                    </span>
                  </Button>
                </div>
              );
            })}
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <Button
                round
                size="sm"
                // color="github"
                // className={classes.buttonBig}
                // color="info"
                onClick={() => {
                  setShowAlert(false);
                }}
                className={`${classesAlert.buttonAlert}`}
                style={{
                  marginRight: "10px",
                  marginLeft: "10px",
                  backgroundColor: `${customStyle.buttonBackToMenu}`
                }}
              >
                <span className={classes.buttonTextNormal}>
                  {t("menuList.cancel_button").toUpperCase()}
                </span>
              </Button>
              <Button
                round
                size="sm"
                color="warning"
                // className={classes.buttonBig}
                // color="info"
                onClick={onSuccess}
                className={`${confirmClass}`}
                style={{
                  backgroundColor: `${customStyle.buttonCart}`
                }}
              >
                <span className={classes.buttonTextNormal}>
                  {t("payment.meal_voucher").toUpperCase()}
                </span>
              </Button>
            </div>
          </div>
        </SweetAlert>
      ) : null}
    </>
  );
}

CashPayButton.propTypes = {
  // language: PropTypes.string,
  // customDiscount: PropTypes.object,

  totalPrice: PropTypes.number.isRequired,
  deliveryPrice: PropTypes.number.isRequired,
  servicePrice: PropTypes.number.isRequired,
  subPrice: PropTypes.number.isRequired,

  language: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  commit: PropTypes.bool,
  cart: PropTypes.array.isRequired,
  coupon: PropTypes.object,
  discount: PropTypes.number,
  vat: PropTypes.number,
  shippingInfo: PropTypes.shape({
    // SHIPPING INFO
    city: PropTypes.string,
    subLocality: PropTypes.string,
    cap: PropTypes.string,
    address: PropTypes.string,
    indoor: PropTypes.string,
    floor: PropTypes.any,
    // telephoneDelivery: PropTypes.string,
    date: PropTypes.any,
    time: PropTypes.string,
    // CONTACTS
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    telephone: PropTypes.string
  }).isRequired,
  restaurantId: PropTypes.string,
  active: PropTypes.bool.isRequired,
  advisorId: PropTypes.string,
  paymentResponse: PropTypes.func,
  feeCosts: PropTypes.number,
  deliveryCosts: PropTypes.number,

  customStyle: PropTypes.object,
  showPopup: PropTypes.bool,
  mealVoucherArray: PropTypes.arrayOf(PropTypes.object)
};

CashPayButton.defaultProps = {
  restaurantId: null,
  language: "it",
  customDiscount: {},
  commit: false,
  prevExpiringDate: null,
  coupon: {},
  vat: 0,
  discount: 0,
  advisorId: "",
  paymentResponse: () => {},
  feeCosts: 0,
  deliveryCosts: 0,
  customStyle: {},
  mealVoucherArray: []
};
